import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=53b2d422&"
import script from "./CategoryPage.vue?vue&type=script&lang=js&"
export * from "./CategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports